export default "__VITE_ASSET__B$u2jqcQ__"